import React, { Component } from 'react'


class About extends Component {


  render() {
    return (
      <div className="About">
        <main className="container">
          <h3>请使用Chrome浏览器插件MetaMask切换到Rinkeby测试网络，本站不支持Main Ethereum Network及其他Test Network。</h3>
          本站只使用Rinkeby Test Network，以太币都可以免费领取，不需要花钱！不需要花钱！不需要花钱！
          为避免出现意外，请不要在Main Ethereum Network使用本站。
          Rinkeby测试网络以太币领取方式：
          <a href="https://faucet.rinkeby.io" target="_blank">https://faucet.rinkeby.io</a>
          <h3>如无法正常使用，可能需要科学上网。</h3>
          然后，毕竟是不要钱的测试网络，可能时不时会不稳定，见谅。
          <h3>这个破网站是做什么用的？</h3>
          做着玩儿的，没什么用，就是领老婆币然后给喜欢的角色投币，没有交易功能（反正不涉及真钱，不需要交易功能）
          <h3>为什么要做这个？</h3>
          只是之前看别人提到“老婆币”这东西，正好最近开发需要先熟悉下。
          <h3>为什么只有18年1月番的角色？</h3>
          懒得多爬数据。
          <h3>为什么不搞“老公币”？</h3>
          姬佬才不搞“老公币”。
        </main>
      </div>
    );
  }
}

export default About



// WEBPACK FOOTER //
// ./src/views/About.js